/**
 * Przełącznik trybu ciemnego — ładowany na każdej stronie frontu.
 */

import { onReady } from '../modules/dom.js';
import { initThemeToggle } from '../modules/theme-toggle.js';

onReady(initThemeToggle);
